import { Component, Input, OnInit, ElementRef, ViewChild } from '@angular/core';
import { MAP_DISTANCE_MILES } from '@app/core/constants/string-constants';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-distance',
  templateUrl: './distance.component.html',
  styleUrls: ['./distance.component.scss'],
  standalone: false,
})
export class DistanceComponent implements OnInit {
  @Input() distanceInMiles = 50;
  @Input() globalDistanceMile = 50;
  miles = MAP_DISTANCE_MILES;
  distance: number;
  @ViewChild('distanceRange', { read: ElementRef })
  distanceRange!: ElementRef;

  constructor(private modalCtrl: ModalController, private translateService: TranslateService) {}

  ngOnInit() {
    if (this.globalDistanceMile > 100) {
      this.miles[5] = {
        label: '100+',
        value: this.globalDistanceMile,
      };
    }
    this.distance = this.miles.findIndex(
      (mile) => mile.value === (this.distanceInMiles || 5)
    );
  }

  ngAfterViewInit(){
    this.updateRangeAccessibility()
  }

  apply() {
    this.modalCtrl.dismiss(this.miles[this.distance].value);
  }


updateRangeAccessibility() {
  setTimeout(() => {
    const rangeElement =
      this.distanceRange.nativeElement;

    const knobHandle =
      rangeElement.shadowRoot?.querySelector(
        '.range-knob-handle'
      );

    if (knobHandle) {
      const valueText =
        this.miles[this.distance].value +
        ' ' +
        (this.miles[this.distance].value === 1
          ? this.translateService.instant('MILE')
          : this.translateService.instant('MILES'));
      knobHandle.setAttribute(
        'aria-valuetext',
        valueText
      );
    }
  });
}
}
